import type { TodoCategory } from '../types/todo.js';

const CATEGORIES_URL = '/api/categories';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getCategories(): Promise<TodoCategory[]> {
  return fetchJson<TodoCategory[]>(CATEGORIES_URL);
}

export async function createCategory(data: { name: string; color?: string }): Promise<TodoCategory> {
  return fetchJson<TodoCategory>(CATEGORIES_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function updateCategory(id: number, data: { name?: string; color?: string }): Promise<TodoCategory> {
  return fetchJson<TodoCategory>(`${CATEGORIES_URL}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function deleteCategory(id: number): Promise<void> {
  const response = await fetch(`${CATEGORIES_URL}/${id}`, { method: 'DELETE' });
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
}
